window.alpha_oms = {}